export default "__VITE_ASSET__akeBlwAF__"